/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InventorySnapshotDtoResponse } from '../models/InventorySnapshotDtoResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DrugInventoryService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns InventorySnapshotDtoResponse Success
     * @throws ApiError
     */
    public getApiDrugInventorySnapshot(): CancelablePromise<InventorySnapshotDtoResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/DrugInventory/Snapshot',
            errors: {
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
}
